import { Module, VuexModule, Mutation, MutationAction, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { ISettingsReport, SettingsReport } from '../models/settingsReport/settingsReport';
import { SettingsReportService } from '@/services';

export interface ISettingsReportStoreState {
    settingsReports: ISettingsReport[];
}

@Module({ dynamic: true, store, name: 'settingsReportStore' })
class SettingsReportStoreModule extends VuexModule {
    public settingsReports: SettingsReport[] = [];

    /**
     * Fetch whole settingsReports
     *
     * Note:
     * 'settingsReports' are replaced by returned object
     * whose shape must be `{settingsReports: [...]}`
     */
    @MutationAction({ mutate: ['settingsReports'] })
    public async FetchSettingsReports() {
        const response: SettingsReport[] = await SettingsReportService.FetchSettingsReports();
        return { settingsReports: response };
    }

    /**
     * Getter for configuration
     */
    get GetSettingsReports() {
        return this.settingsReports;
    }
}

export const SettingsReportStore = getModule(SettingsReportStoreModule);
